import useCountDown from "@pathwright/ui/src/components/hooks/useCountDown"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import UnlocksOverlay from "@pathwright/ui/src/components/overlay/UnlocksOverlay"
import ProgressPieChart from "@pathwright/ui/src/components/progress/ProgressPieChart"
import PreventOrphan from "@pathwright/ui/src/components/text/PreventOrphan"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import { default as UIText } from "@pathwright/ui/src/components/ui/Text"
import { PRIMARY_GRAY } from "@pathwright/ui/src/components/utils/colors"
import PathDue from "@pathwright/web/src/modules/path/ui/PathDue"
import PathScheduleLabel from "@pathwright/web/src/modules/path/ui/PathScheduleLabel"
import classnames from "classnames"
import { Text } from "lib/core/components/text"
import ItemPublishStatus from "library/show/components/publish/ItemPublishStatus"
import get from "lodash/get"
import moment from "moment"
import { DESIGN, LEARN, PREVIEW } from "path/constants"
import * as dateUtils from "path/utils"
import PropTypes from "prop-types"
import PeopleHere from "../analytics/PeopleHere"
import "./PathGroupDetails.css"

const PathGroupDetails = function (props, context) {
  const { mode } = context || {}

  const {
    group,
    stats,
    path,
    expanded,
    analytics,
    isNext,
    isInactive,
    startsDate,
    onToggleExpand
  } = props
  const { t } = useTranslate()

  // TODO: startsDateForceUpdate not working - not removing lock icon in ProgressPieChart after countdown is reached...
  const startsDateForceUpdate = useCountDown(startsDate)
  const { name, description, content, items, order } = group

  const showAnalytics = analytics && !expanded && mode !== DESIGN
  const className = classnames("PathGroupDetails", {
    "PathGroupDetails--expanded": expanded,
    "PathGroupDetails--collapsed": !expanded,
    "PathGroupDetails--inactive": isInactive
  })

  let progress = 0
  if (mode === LEARN) {
    // show learner progress
    progress = get(stats, "progress", 0)
  } else {
    // show learners progress (from analytics data)
    // analytics are the analytics for this item
    const { next_count, complete } = analytics || {
      next_count: 0,
      complete: 0
    }

    // essentially matching the same data shown in the stats PathItemControl
    progress = complete / (next_count + complete) || 0 // 0 / 0 //=> NaN, so we prefer 0 to NaN :)
  }

  return (
    <div className={className} onClick={onToggleExpand}>
      {mode === LEARN && <PathDue pathItem={group} inverted={isInactive} />}
      {mode > PREVIEW && mode < DESIGN && (
        <ProgressPieChart
          className="PathGroupDetails__progress"
          progress={progress}
          inverted={isInactive}
          locked={!!startsDate && moment(startsDate).isAfter()}
        />
      )}
      {!!startsDate && mode === LEARN && (
        <div>
          <UIText.Meta
            inverted={isInactive}
            style={{ color: !isInactive && PRIMARY_GRAY }}
          >
            <UnlocksOverlay starts={startsDate} inverted={isInactive} />
          </UIText.Meta>
        </div>
      )}
      <h3 className="PathGroupDetails__title theme-heading theme-heading-bold">
        <PreventOrphan text={name} />
      </h3>
      {!!description && (
        <Text className="PathGroupDetails__description" html={description} />
      )}
      {mode === LEARN && (
        <UIText.Meta>
          <PathScheduleLabel
            pathItem={group}
            showIcon
            inverted={isInactive}
            collapse
          />
        </UIText.Meta>
      )}
      {!expanded && (
        <UIText.Meta className="PathGroupDetails__meta">
          {mode === DESIGN && <ItemPublishStatus item={group} />}
          {showAnalytics && (
            <PeopleHere
              item={group}
              inverted={isInactive}
              hideAvatars={mode === LEARN && isInactive}
              includeSelf={mode === LEARN && isNext}
              limit={isInactive ? 5 : 10}
            />
          )}
          {!!stats && stats.time_to_complete > 0 && (
            <Tooltip
              title="Est. time to complete"
              className="PathGroupDetails__stats"
            >
              {dateUtils.getEstimatedTimeDisplay(stats.time_to_complete, t)}
            </Tooltip>
          )}
        </UIText.Meta>
      )}
    </div>
  )
}

PathGroupDetails.displayName = "PathGroupDetails"
PathGroupDetails.contextTypes = { mode: PropTypes.number }

export default PathGroupDetails
